package com.example.mystybag.communication.utils

import com.example.mystybag.communication.ext.CommandResult
import com.example.mystybag.communication.utils.CommunicationUtilsHelper.logout
import com.example.mystybag.communication.utils.Response.getErrorMessage
import com.example.mystybag.core.logic.base.AppViewModel.Companion.showSnackbar
import com.example.mystybag.core.model.SnackbarConfig
import com.example.mystybag.sharedmodels.base.BaseResponseModel
import com.example.mystybag.sharedmodels.defines.ServerStatusDefines.Companion.STATUS_TOKEN_IS_EXPIRED

suspend fun <SuccessModel: BaseResponseModel, ErrorModel> CommandResult<SuccessModel, ErrorModel>.onResponse(
    success             : suspend (SuccessModel) -> Unit,
    error               : (suspend (ErrorModel) -> Unit)?           = null,
    baseError           : (suspend (BaseResponseModel) -> Unit)?    = null
) {
    when (this) {
        is CommandResult.Success    -> {
            success.invoke(successModel)
        }
        is CommandResult.Error      -> error?.invoke(errorModel)
        is CommandResult.BaseError  ->
            when (baseErrorModel.status) {
                STATUS_TOKEN_IS_EXPIRED    -> logout()
                else                        -> baseError?.invoke(baseErrorModel) ?: showSnackbar(SnackbarConfig(getErrorMessage(baseErrorModel.status, baseErrorModel.api, baseErrorModel.statusMessage)))
            }

    }
}

fun <SuccessModel: BaseResponseModel, ErrorModel> CommandResult<SuccessModel, ErrorModel>.getOrNull(): SuccessModel? = if (this is CommandResult.Success) this.successModel else null

suspend fun <SuccessModel: BaseResponseModel, ErrorModel> CommandResult<SuccessModel, ErrorModel>.onSuccess(block: suspend (SuccessModel) -> Unit) = this.onResponse(success = block)